import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>بصمة آثر وآركان أكاديمي</h3>
            <p>مؤسسة لدعم المواهب الأدبية والفنية</p>
            <p>هدفنا بسيط… وواحد: ندعمك، نؤمن بيك، ونوصلك لهدفك مهما كان 🌟</p>
          </div>
          <div className="footer-section">
            <h4>روابط سريعة</h4>
            <ul>
              <li>
                <button onClick={() => scrollToSection('home')}>الرئيسية</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('books')}>الكتب</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')}>المعرض</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('interviews')}>الحوارات</button>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>تابعنا</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 بصمة آثر وآركان أكاديمي. جميع الحقوق محفوظة.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
